import { Slide } from "react-reveal";
import FaqCardList from "../reusables/FaqCardList";
import OtherFAQs from "../reusables/OtherFAQs";

const SMManagementFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="How often will you post on my social media accounts?">
                  <p>
                    Posting frequency depends on your strategy and goals.
                    Typically:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>1-3 posts per day for steady growth</span>
                    </li>
                    <li>
                      <span>More for aggressive campaigns</span>
                    </li>
                  </ul>
                  <p>
                    We define a schedule that balances consistency, quality, and
                    performance.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will you create the content or do I have to provide it?">
                  <p>
                    We handle content creation except for specific brand and
                    company content. For content we create includes:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Graphics and visuals</span>
                    </li>
                    <li>
                      <span>Captions and messaging</span>
                    </li>
                    <li>
                      <span>Content planning</span>
                    </li>
                  </ul>
                  <p>
                    We may occasionally request input (e.g specific products,
                    updates), but we do the heavy lifting.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Which platforms will you manage?">
                  <p>
                    It depends on where your audience is. We commonly manage:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Instagram</span>
                    </li>
                    <li>
                      <span>Facebook</span>
                    </li>
                    <li>
                      <span>LinkedIn</span>
                    </li>
                    <li>
                      <span>TikTok</span>
                    </li>
                  </ul>
                  <p>
                    We focus on platforms that bring real results for your
                    brand.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will this actually grow my audience?">
                  <p>Yes—but growth depends on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Consistency</span>
                    </li>
                    <li>
                      <span>Content quality</span>
                    </li>
                    <li>
                      <span>Strategy</span>
                    </li>
                  </ul>
                  <p>
                    We use proven systems to increase reach, engagement, and
                    followers over time.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I get customers or just likes and followers?">
                  <p>Our focus is not vanity metrics. We aim for:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Leads</span>
                    </li>
                    <li>
                      <span>Inquiries</span>
                    </li>
                    <li>
                      <span>Sales</span>
                    </li>
                  </ul>
                  <p>Engagement is important—but conversion is the goal.</p>
                </FaqCardList>

                <FaqCardList faq="Do you respond to messages and comments?">
                  <p>Yes. We handle:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Comments</span>
                    </li>
                    <li>
                      <span>Messages (based on agreed scope)</span>
                    </li>
                    <li>
                      <span>Audience engagement</span>
                    </li>
                  </ul>
                  <p>This builds trust and strengthens your brand.</p>
                </FaqCardList>
                <FaqCardList faq="Do I still need to be involved?">
                  <p>Minimal involvement is required. You may:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Approve content</span>
                    </li>
                    <li>
                      <span>Provide occasional updates</span>
                    </li>
                  </ul>
                  <p>We handle the strategy, content, and execution.</p>
                </FaqCardList>
                <FaqCardList faq="Can you run ads as part of social media management?">
                  <p>Yes. We can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Set up and manage ad campaigns</span>
                    </li>
                    <li>
                      <span>Target the right audience</span>
                    </li>
                    <li>
                      <span>Optimize performance</span>
                    </li>
                  </ul>
                  <p>Ads help accelerate growth and results.</p>
                </FaqCardList>
                <FaqCardList faq="How long does it take to see results?">
                  <ul className="faq-ulist">
                    <li>
                      <span>Engagement improvements: within weeks</span>
                    </li>
                    <li>
                      <span>Audience growth: 1–2 months</span>
                    </li>
                    <li>
                      <span>Strong business impact: consistent over time</span>
                    </li>
                  </ul>
                  <p>
                    Social media growth and results compound with consistency
                    over time.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I be able to see results and performance?">
                  <p>Yes. You’ll receive:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Performance reports</span>
                    </li>
                    <li>
                      <span>Insights and recommendations</span>
                    </li>
                    <li>
                      <span>Growth tracking</span>
                    </li>
                  </ul>
                  <p>Full transparency at all times.</p>
                </FaqCardList>
                <FaqCardList faq="Can you match my brand’s voice and style?">
                  <p>Yes. We align with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Your brand identity</span>
                    </li>
                    <li>
                      <span>Tone of voice</span>
                    </li>
                    <li>
                      <span>Visual style</span>
                    </li>
                  </ul>
                  <p>Everything stays consistent with your brand.</p>
                </FaqCardList>
                <FaqCardList faq="What if I already have social media accounts?">
                  <p>No problem. We can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Audit and review your accounts</span>
                    </li>
                    <li>
                      <span>Improve performance</span>
                    </li>
                    <li>
                      <span>Reposition your content strategy</span>
                    </li>
                  </ul>
                  <p>We build on what you already have.</p>
                </FaqCardList>
                <FaqCardList faq="What makes NTUNA.COM different from other social media managers?">
                  <p>We don’t just post content.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Strategy-driven approach</span>
                    </li>
                    <li>
                      <span>Focus on growth and conversions</span>
                    </li>
                    <li>
                      <span>Continuous optimization</span>
                    </li>
                  </ul>
                  <p>You get a system—not just activity.</p>
                </FaqCardList>
                <FaqCardList faq="Is social media management worth it?">
                  <p>Yes—because it directly impacts:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Visibility</span>
                    </li>
                    <li>
                      <span>Brand perception</span>
                    </li>
                    <li>
                      <span>Customer trust</span>
                    </li>
                  </ul>
                  <p>
                    A strong social presence can drive real business growth.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your needs</span>
                    </li>
                    <li>
                      <span>Understand your business and audience</span>
                    </li>
                    <li>
                      <span>Define your strategy</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Start managing your accounts</span>
                    </li>
                  </ul>
                </FaqCardList>
              </ul>
            </div>
            <OtherFAQs />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SMManagementFaqsBody;
